import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger
} from '@ps-design-system/components/Accordion';
import { Text } from '@ps-design-system/components/Text';
import PropTypes from 'prop-types';
import * as React from 'react';
import { FormattedMessage } from 'react-intl';

export const CancellationPolicySection = ({ cancellationPolicy }) => {
  return (
    <Accordion collapsible={true}>
      <AccordionItem value={cancellationPolicy.id} showDivider={false}>
        <AccordionTrigger>
          <Text
            testId="cancellation-policy-title"
            element="h4"
            typeface="headline-1-m"
            style={{ margin: '0px', textAlign: 'left' }}
          >
            <FormattedMessage
              id="cancellation_policy.title"
              defaultMessage="Cancellation policy: {name} {gracePeriod}"
              values={{
                name: cancellationPolicy.name,
                gracePeriod: cancellationPolicy.grace_period_applies ? (
                  <FormattedMessage
                    id="cancellation.policy_title.with_grace"
                    defaultMessage="with grace period"
                  />
                ) : (
                  ''
                )
              }}
            />
          </Text>
        </AccordionTrigger>
        <AccordionContent>
          {(
            cancellationPolicy.short_description ||
            cancellationPolicy.description ||
            []
          ).map((desc, index) => (
            <Text
              testId="cancellation-policy-description"
              key={index}
              element="p"
              style={{ margin: '0px' }}
            >
              {desc}
            </Text>
          ))}
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
};

CancellationPolicySection.propTypes = {
  cancellationPolicy: PropTypes.object.isRequired
};
